import { inject } from 'vue';
import type { InjectionKey } from 'vue';
import type { LayoutInitHookLoader } from '../types/mainLayout.type';

/** Key con la que la raíz de composición (`main.ts`) registra los hooks de inicialización de MainLayout. */
export const LAYOUT_INIT_HOOKS_PROVIDER_KEY: InjectionKey<LayoutInitHookLoader[]> =
  Symbol('layoutInitHooksProvider');

/**
 * Devuelve los loaders registrados o una lista vacía.
 * No lanza: los hooks son opcionales y, sin ellos, el layout solo carga el estado KYC.
 */
export function injectLayoutInitHookLoaders(): LayoutInitHookLoader[] {
  return inject(LAYOUT_INIT_HOOKS_PROVIDER_KEY, []);
}
